import React from "react";
import { NavigationMenuLink } from "../../ui/navigationmenu";
import { cn } from "../../../lib/utils";
import { WrenchIcon } from "@heroicons/react/24/solid";

export const ListItem = React.forwardRef(
  ({ className, title, href, icon: Icon, children }, ref) => {
    const isClickable = href && href.trim() !== "";
    const isUnderProduction = Icon === WrenchIcon;

    return (
      <li className="relative group">
        <NavigationMenuLink asChild>
          <a
            ref={ref}
            href={isClickable ? href : "#"}
            target={isClickable ? "_blank" : undefined}
            rel={isClickable ? "noopener noreferrer" : undefined}
            onClick={!isClickable ? (e) => e.preventDefault() : undefined}
            className={cn(
              "flex w-full flex-col rounded-md px-3 py-2 text-left no-underline outline-none transition-colors",
              isClickable && "hover:bg-slate-800 cursor-pointer",
              !isClickable && "cursor-default opacity-60",
              className
            )}
          >
            <div className="text-sm font-medium text-white leading-snug">{title}</div>
            <p className="text-xs text-slate-400 leading-tight">{children}</p>
          </a>
        </NavigationMenuLink>

        {isUnderProduction && (
          <div className="absolute bottom-full left-1/2 z-10 mb-2 -translate-x-1/2 w-max px-3 py-1.5 bg-gray-950 text-white text-xs font-semibold rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            Under production
          </div>
        )}
      </li>
    );
  }
);

ListItem.displayName = "ListItem";
